import PropTypes from 'prop-types';
import React from 'react';

import './index.scss';
import { shortMonth } from '../../../../lib/dateFormatter';
import ChosenSchoolDetailsDisplay from '../ChosenSchoolDetailsDisplay';

const OfferHeader = ({
  schoolName,
  universityName,
  courseName,
  periodStartDate,
  periodEndDate,
  seasonClassStartDate,
  seasonClassEndDate,
  tuitionFees,
  livingExpenses,
  restOfWorldCourse,
  selectedOffer,
}) => {
  const formattedSeasonClassStartDate = shortMonth(new Date(seasonClassStartDate));
  const formattedSeasonClassEndDate = shortMonth(new Date(seasonClassEndDate));

  return (
    <>
      <div className="offer-header-container-v3">
        <div className="offer-header-container-v3__congrats-title">Congratulations!</div>
        <div className="offer-header-container-v3__congrats-message">
          You have a provisional offer!
        </div>

        <div className="offer-header-container-v3__text-container">
          <div className="offer-header-container-v3__text bold school-icon">{universityName}</div>
          <div className="offer-header-container-v3__text">{schoolName}</div>
        </div>

        <div className="offer-header-container-v3__text-container">
          <div className="offer-header-container-v3__text book-icon">{courseName}</div>
          <div className="offer-header-container-v3__text">
            ({formattedSeasonClassStartDate} - {formattedSeasonClassEndDate})
          </div>
        </div>

        <ChosenSchoolDetailsDisplay
          schoolName={schoolName}
          universityName={universityName}
          courseName={courseName}
          periodStartDate={periodStartDate}
          periodEndDate={periodEndDate}
          seasonClassStartDate={seasonClassStartDate}
          seasonClassEndDate={seasonClassEndDate}
          tuitionFees={tuitionFees}
          livingExpenses={livingExpenses}
          restOfWorldCourse={restOfWorldCourse}
          selectedOffer={selectedOffer}
        />
      </div>
    </>
  );
};

OfferHeader.propTypes = {
  schoolName: PropTypes.string.isRequired,
  universityName: PropTypes.string.isRequired,
  courseName: PropTypes.string.isRequired,
  periodStartDate: PropTypes.string.isRequired,
  periodEndDate: PropTypes.string.isRequired,
  seasonClassStartDate: PropTypes.string.isRequired,
  seasonClassEndDate: PropTypes.string.isRequired,
  tuitionFees: PropTypes.string.isRequired,
  livingExpenses: PropTypes.string.isRequired,
  restOfWorldCourse: PropTypes.bool.isRequired,
  selectedOffer: PropTypes.object,
};

export default OfferHeader;
